import './app.css';
import '@babel/polyfill';

import WebFont from 'webfontloader';
import lazySizes from 'lazysizes';
import {analyticsEvent, attrEvents} from './js/analytics';
import Swiper from 'swiper';
import * as VanillaSharing from 'vanilla-sharing';
import meta from './data/meta.json';
import {parallaxController} from './js/parallaxController.js';
import shareHandler from './js/share';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}

const data = require('./data/basic.json');

/* fonts */
WebFont.load({
    custom: {
        families: ['Geometria:n5,n7', 'Anglecia Pro Title:n7'],
        urls: ['./css/fonts.css']
    }
    /*
    google: {
        families: ['Roboto:400,700:cyrillic']
    },*/
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
analyticsEvent();
attrEvents();

/* lazy loading (https://github.com/aFarkas/lazysizes) */
lazySizes.init();

/* share buttons with lazyloading
const shareButtonsContainer = document.querySelector('.share');
if (shareButtonsContainer !== null) {
    shareButtonsContainer.addEventListener('lazyloaded', () => {
        import( './js/share').then(func => {
            func.default();
        });
    });
}
 */

/* eslint-disable */
var isMobile = false;
if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
    )
) {
    isMobile = true;
}
/* eslint-enable */

shareHandler([...document.querySelectorAll('.header__shares .share__item')]);

const defaultButtons = [...document.querySelectorAll('.swiper-container-last .share__item')];

const defaultOptions = {
    url: meta.url,
    title: meta.title,
    description: meta.description,
    image: meta.image,
    isVkParse: false,
    fbAppId: meta.fbappid
};

defaultButtons.forEach(button => {
    const social = button.dataset.social;
    const isNativeShare = social === 'all' && navigator.share !== undefined;

    if (isNativeShare) {
        button.classList.add('share__item--show');
    }

    button.addEventListener('click', () => {
        if (isNativeShare) {
            navigator.share({
                title: defaultOptions.title,
                url: defaultOptions.url
            });
        } else {
            VanillaSharing[social](defaultOptions);
        }
    });
});

let lastSwiper = {};
if (!isMobile) {
    lastSwiper = new Swiper('.swiper-container-last', {
        direction: 'vertical',
        mousewheel: true
    });
}

class Test {
    constructor(init, questions, results) {
        this.init = init; // Инициализация теста
        this.questions = questions; // Массив вопросов
        this.results = results; // Объект содержащий результаты
        this.rightAnswers = 0; // Количество правильных ответов
        this.questionQuantity = questions.length; // Количество вопросов
        this.wolves = 0;
        this.lions = 0;
        this.horses = 0;
        this.endImages = [...document.querySelectorAll('.swiper-slide--result .resultimage')];

        this.swiper = new Swiper(`${init.swiperContainerClass}`, init.swiperConfig);

        /* назначаем resultHeader, resultDescription и resultCounter контейнерами заголовка текста результата и счетчика правильных ответов соответсвтенно*/
        const resultHeaderArr = [...document.querySelectorAll(`${init.resultHeaderClass}`)];
        this.resultHeader = resultHeaderArr.length > 0 ? resultHeaderArr[0] : false;

        const resultDescriptionArr = [...document.querySelectorAll(`${init.resultDescriptionClass}`)];
        this.resultDescription = resultDescriptionArr.length > 0 ? resultDescriptionArr[0] : false;

        const resultCounterArr = [...document.querySelectorAll(`${init.resultCounterClass}`)];
        this.resultCounter = resultCounterArr.length > 0 ? resultCounterArr[0] : false;

        /* Если тест начинается с заглушки - назначаем кнопку для перехода на первый вопрос */
        if (init.firstpage === true && init.startTestButtonClass) {
            document.querySelectorAll(`${init.startTestButtonClass}`)[0].addEventListener('click', () => {
                this.startTest();
            });
        }

        /* Ставим Listeners на кнопки(контейнеры, изображения) ответов */
        const answerButtons = [...document.querySelectorAll(`${init.answerButtonClass}`)];
        this.answerButtons = answerButtons;
        answerButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.checkAnswer(button.dataset);
            });
        });

        /* Ставим Listeners на кнопки(контейнеры, изображения) переходов к
           следующему вопросу
        */
        const nextQuestionButtons = [...document.querySelectorAll(`${init.nextQuestionButtonClass}`)];
        if (nextQuestionButtons.length > 0) {
            nextQuestionButtons.forEach(button => {
                button.addEventListener('click', () => {
                    this.nextQuestion(button.dataset);
                });
            });
            /* Заменяем текст на последней кнопке перехода на указаный в init */
            this.nextQuestionLinks = nextQuestionButtons;
            nextQuestionButtons[nextQuestionButtons.length - 1].querySelector('span').innerHTML = init.lastNextButtonText;
        }

        /* Ставим Listeners на кнопку рестарта теста при наличии оного */
        const repeatButton = [...document.querySelectorAll(`${init.repeatTestClass}`)];
        if (repeatButton.length > 0) {
            repeatButton[0].addEventListener('click', () => {
                this.repeatTest();
            });
        }

        const swBlock = document.querySelector('.swiper-container .swiper-wrapper');
        this.swiper.on('slideChange', () => {
            if (isMobile) {
                swBlock.scrollTop = 0;
                window.scrollTo(0, 0);
            }
        });
    }

    startTest() {
        this.swiper.slideNext();
    }

    checkAnswer(answerData) {
        let {question, answer, type} = answerData;
        question = +question;

        /* проверка правильности ответа - результат boolean переменная gotRight -
        true вслучае правильного ответа */
        const gotRight = ++answer === this.questions[question].rightAnswer ? true : false;

        /* если ответ был правильным - увеличиваем счетчик правильных ответов на 1 */
        if (gotRight) {
            ++this.rightAnswers;
        }

        switch (type) {
            case 'horse':
                this.horses += 1;
                break;
            case 'wolf':
                this.wolves += 1;
                break;
            case 'lion':
                this.lions += 1;
                break;
        }

        /* если результат ответа на следущюей странице - переход, если нет - действие */
        if (this.init.twoPageQuestion) {
            this.swiper.slideNext();
            parallaxController.destroy();
            parallaxController.init(this.swiper.activeIndex);
        } else {
            /*
               действие на странце c вопросом после клика пользователя по варианту ответа:
               например включение кнопки перехода к следующему вопросу или
               подсветка нужным цветом правильного\неправильного ответа
            */
            this.nextQuestionLinks[question].disabled = false;

            /* добавляем класс всем ответам актуального вопроса для запрета повторного выбора */
            this.answerButtons.forEach(button => {
                if (+button.getAttribute('data-question') === question) {
                    button.classList.add('closed');
                }
            });
        }
    }

    nextQuestion(index) {
        +index.question < this.questionQuantity - 1 ? this.swiper.slideNext() : this.endTest();
    }

    endTest() {
        let result = 'wolf';
        result = this.lions > 2 ? 'lion' : result;
        result = this.horses > 2 ? 'horse' : result;

        /*
        console.log("lions" + this.lions)
        console.log("horses" + this.horses)
        console.log("wolves" + this.wolves)
        */
        /*
           если нужно добавить больше 3 вариантов финала нужно изменить следующие две строки
           и добавить необходимые брейкпоинты в конфиг
        */
        /*
        this.rightAnswers < this.init.resultBreakPointOne ? result = "lose" :
        this.rightAnswers < this.init.resultBreakPointTwo ? result = "neutral" : result = "win";
        */

        /* в контейнеры результатов resultHeader и resultDescription добавляется текст согласно результату */
        if (this.resultHeader) {
            this.resultHeader.innerHTML = this.results[result].header;
        }
        if (this.resultDescription) {
            this.resultDescription.innerHTML = this.results[result].description;
        }

        /* добавить количество правильных ответов в результатах
        if (this.resultCounter) {this.resultCounter.innerHTML = `${this.rightAnswers} / ${this.questions.length}`}
        */

        this.endImages.forEach(image => {
            image.classList.add('hide');
            if (image.dataset.image === result) {
                image.classList.remove('hide');
            }
        });

        /* настройка шаринга согласно результатам теста */
        defaultOptions.url = this.results[result].url;
        defaultOptions.title = this.results[result].header;
        defaultOptions.description = this.results[result].description;

        /*
        shareHandler([...document.querySelectorAll('.swiper-container-last .share__item')], {
            url: this.results[result].url,
            title: this.results[result].header,
            description: this.results[result].description,
            image: this.results[result].imgshare
        });
        */

        /* переход к последнему сайту содержащему результат */
        this.swiper.slideNext();
    }

    repeatTest() {
        /* обнуляем счетчик ответов */
        this.rightAnswers = 0;
        this.wolves = 0;
        this.lions = 0;
        this.horses = 0;

        /* чистим кнопки ответов */
        this.answerButtons.forEach(button => {
            button.classList.remove('closed');
        });

        /* делаем кнопки продолжения неактивными при тесте с одной страницей на вопрос */
        if (!this.init.twoPageQuestion) {
            this.nextQuestionLinks.forEach(link => {
                link.disabled = true;
            });
        }

        this.init.firstpage ? this.swiper.slideTo(1) : this.swiper.slideTo(0);
        lastSwiper.slideTo(0);
    }
}

const testConfig = {
    firstpage: true, // true если тест начинается с "заглавной страницы"
    startTestButtonClass: '.start-test', // класс кнопки начала теста
    twoPageQuestion: true, // true если описание ответа на следующей после вопроса странице
    lastNextButtonText: 'Узнать результат', // название последней кнопки теста
    resultBreakPointOne: 2, // минимальное количество правильных ответов для среднего результата
    resultBreakPointTwo: 4, // минимальное количество правильных ответов для максимального результата
    resultHeaderClass: '.result-header', // класс заголовка результата
    resultDescriptionClass: '.result-description', // класс описания результата
    resultCounterClass: '.result-counter', // класс счетчика результата
    nextQuestionButtonClass: '.next-question', // класс кнопки перехода к следующему вопросу
    answerButtonClass: '.answer-button', // класс кнопки ответа на вопрос
    repeatTestClass: '.repeat-test', // класс кнопки "начать заново"
    swiperContainerClass: '.swiper-container', // класс контейнера swiper
    swiperConfig: {
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoHeight: isMobile
    }
};

new Test(testConfig, data.questions, data.result);
